/**
 * NOTE: Name with `BG` word
 */
import screenImageBG from './screen.png';
// tile background images
import announcementsBG from './bg-announcements.jpg';
import cardManualsBG from './bg-card_manuals.jpg';
import cardConfigurationBG from './bg-card_product_config.jpg';
import cardPricingHelperBG from './bg-card_pricing-helper.jpg';
import cardProductEducationBG from './bg-card_product-education.jpg';
import cardSalesGuidanceBG from './bg-card_sales-guidance.jpg';
import cardWarrantyClaimBG from './bg-card_warranty-claim.jpg';
import cardWarrantyRegistrationBG from './bg-card_warranty-registration.jpg';
import cardPartsBG from './bg-card-parts.jpg';

// tools background
import configBinBg from './configBin.png';
import calculateBg from './calculate.png';
import salesBg from './sales.png';
import newPartsTileBG from './newPartsTile.png';
import newRegisterTileBG from './newRegisterTile.png';
import newMarketingTileBG from './newMarketingTile.png';
import newSellingTileBG from './newSellingTile.png';
import newLearningTileBG from './newLearningTile.png';
import newManualsTileBG from './newManualsTile.png';
import newWarrantyClaimBG from './newWarrantyClaim.png';

export {
  screenImageBG,
  announcementsBG,
  cardManualsBG,
  cardConfigurationBG,
  cardPricingHelperBG,
  cardProductEducationBG,
  cardSalesGuidanceBG,
  cardWarrantyClaimBG,
  cardWarrantyRegistrationBG,
  cardPartsBG,
  configBinBg,
  calculateBg,
  salesBg,
  newPartsTileBG,
  newRegisterTileBG,
  newMarketingTileBG,
  newSellingTileBG,
  newLearningTileBG,
  newManualsTileBG,
  newWarrantyClaimBG
};



// WEBPACK FOOTER //
// ./src/images/bg/index.js